<template>
  <div class="wrapper">
    <!-- <div :class="$style.cesiumContainer">
      <img
        :src="require('@/assets/' + $configEnv.GlobalStyle.mainLogo)"
        style="
          width: 100%;
          height: 100%;
          border-top-left-radius: 30px;
          border-bottom-left-radius: 8px;
        "
      />
    </div> -->
    <van-form @submit="handleLogin">
      <div class="logoContainer">
        <img :src="require('@/assets/' + logourl)" />
      </div>
      <div class="titleContainer">
        <h2 class="title">欢迎登录</h2>
      </div>
      <van-field v-model="loginForm.username" name="用户名" label="用户名" placeholder="用户名"
        :rules="[{ required: true, message: '请输入用户名' }]" />
      <van-field v-model="loginForm.password" name="密码" label="密码" placeholder="密码"
        :right-icon="passwordStatus ? 'eye' : 'closed-eye'" :type="!passwordStatus ? 'password' : 'text'"
        @click-right-icon="passwordStatus = !passwordStatus" :rules="[{ required: true, message: '请输入密码' }]">
      </van-field>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">登录</van-button>
      </div>
      <div class="tips">
        <van-checkbox v-model="loginForm.rememberMe" class="rememberUser">记住用户名
        </van-checkbox>
      </div>
    </van-form>
  </div>
</template>

<script>
// import { Route } from 'vue-router'
import axios from 'axios'
import { Encrypt } from './secret'
import yhconfig from '@/yhconfig.js'
import Bridge from "@/utils/Bridge";

export default {
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        rememberMe: ''
      },
      loading: false,
      passwordStatus: false,
      logourl: yhconfig.project === 'zsgly' ? yhconfig.logourlzsgly : yhconfig.logourl
    }
  },
  methods: {
    async receiveActiveMqMessage() {
      let res = await this.$post('/flow/flowbusiness/selectMyTaskList?pageNum=1&pageSize=500')
      let total = res.data.total
      Bridge.callSyncMethod("nativeRequest", {
        nativeMethod: "shortCutBadger",
        data: {
          count: total  //数字  int型
        }
      });
    },
    async handleLogin() {
      let loginFormData = JSON.parse(JSON.stringify(this.loginForm))
      this.loading = true
      if (this.loginForm.rememberMe) {
        localStorage.setItem('rem_userName', this.loginForm.username)
        localStorage.setItem('rem_userPwd', this.loginForm.password)
        localStorage.setItem('rem', this.loginForm.rememberMe)
      } else {
        localStorage.removeItem('rem_userName')
        localStorage.removeItem('rem_userPwd')
        localStorage.removeItem('rem')
      }
      try {
        loginFormData.password = Encrypt(loginFormData.password)
        let res = await this.$post('/login?username=' + loginFormData.username + '&password=' + loginFormData.password, '', 'application/x-www-form-urlencoded')
        if (res.code === 0) {
          sessionStorage.setItem('usertoken', res.data.token)
          sessionStorage.setItem('username', this.loginForm.username)
          this.$router
            .push({
              // 默认访问地址
              path: this.redirect || '/',
              query: this.otherQuery,
            })
            .catch((err) => {
              if (err) {
                // 忽略从导航守卫重定向的错误
              }
            })
          // 获取后端路由
          // message("登录成功", { type: "success" });
          let userAgent = window.navigator.userAgent;
          if (userAgent.indexOf("dimine") != -1) {
            window.receiveActiveMqMessage = this.receiveActiveMqMessage;
            Bridge.callSyncMethod("nativeRequest", {
              nativeMethod: "openActiveMqService",
              data: {
                activeMqUrl: 'tcp://' + window.location.hostname + ':61616',  //activeMq连接地址
                username: 'dimine',
                password: 'dimine',
                topic: "process.topic"
              }
            });
          }
          this.$notify({ type: 'success', message: "登录成功" });
        }
      } catch (err) {
        this.$notify({ type: 'danger', message: err.msg });
        this.loading = false
      }
    }
  },

  async mounted() {
    this.loginForm.username = localStorage.getItem('rem_userName')
    this.loginForm.password = localStorage.getItem('rem_userPwd')
    let reme = localStorage.getItem('rem')
    this.loginForm.rememberMe = JSON.parse(reme)
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  // background-color: $micro--color-primary;
  background-size: 100% 100%;

  .cesiumContainer {
    position: absolute;
    top: 20%;
    left: 21%;
    height: 55%;
    right: 39%;
  }

  .selectContainer {

    .el-form-item__content {
      display: flex;
      align-items: center;

      .el-select {
        flex: 1;

        .el-input {
          width: 100%;
        }
      }
    }

  }

  .el-input {
    display: inline-block;
    height: 38px;
    width: 85%;

    input {
      height: 38px;
      background: transparent;
      border: 0px;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: #454545;
      caret-color: black;
      appearance: none;
    }
  }

  .el-form-item {
    background: #f1f1f4;
    border-radius: 4px;
    color: #454545;
    margin-bottom: 10px;
    margin-top: 20px;

    &.is-error {
      .el-form-item__content {
        border: 1px solid #e85c60;
      }
    }
  }


  .logo {
    position: absolute;
    background-size: 100%;
  }

  .copyright {
    position: absolute;
    z-index: 10;
    bottom: 5%;
    width: 100%;
    color: #fff;
    font-size: 12px;
    text-align: center;
  }

  .contentTitle {
    position: absolute;
    background-size: 100%;
  }

  .content {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background-size: contain;
    overflow: hidden;

    .spot {
      position: absolute;
      z-index: 1;
    }
  }

  .loginForm {
    position: absolute;
    top: 20%;
    right: 19%;
    width: 20%;
    height: 55%;
    max-width: 100%;

    padding: 30px 30px 30px;
    background: #fff;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 30px;
    overflow: hidden;
  }

  @media (max-width: 1200px) {
    .loginForm {
      right: 10%;
      width: 28%;
      padding: 25px 20px 20px;
    }
  }

  @media (max-width: 950px) {
    .loginForm {
      right: 6%;
      width: 36%;
    }
  }

  .svgContainer {
    padding: 0px 5px 0px 15px;
    // color: $darkGray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .logoContainer {
    position: relative;
    text-align: center;
    margin-top: 20px;

    img {
      width: 50%;
      height: 9%;
    }
  }

  .titleContainer {
    position: relative;

    .title {
      // font-size: 18px;
      color: #1d2557;
      margin: 20px auto 30px;
      text-align: center;
      font-weight: 500;
    }

    .setLanguage {
      position: absolute;
      top: 3px;
      font-size: 18px;
      right: 0px;
      cursor: pointer;
    }
  }

  .tips {
    margin: 20px 0px 20px 20px;
    color: rgba(0, 0, 0, 1);

    .rememberUser {
      // color: rgba(0, 0, 0, 1);
      // font-size: 16px;
    }

    .forgetPassword {
      float: right;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      line-height: 20px;
      cursor: pointer;
    }
  }

  .login {
    width: 100%;
    height: 38px;
    border-radius: 10px;
    font-size: 18px;
    // background: $micro--color-primary;
    border: none;
  }

  .showPwd,
  .loginCode {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    // color: $darkGray;
    cursor: pointer;
    user-select: none;
  }

  .verificationCode {
    right: 0px;
    top: 0px;
    height: 38px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue